import { Immutable } from "immer";
import React from "react";
import { useStaticURL } from "tsi-common-react/src/utils/urls";
import { t } from "ttag";

import type { HomeBannerAd as Value } from "@reactivated";

type IProps = Immutable<{
    value: Value | null;
}>;

/**
 * Faithful JSX transcription of the legacy sealy
 * ``components/adverts/home_banner_ad.html`` (#33285). The block is a
 * value-less StaticBlock: the serialized value is an empty object (or null on
 * the standalone template path) and is ignored.
 */
export const HomeBannerAd = (_props: IProps): React.JSX.Element => {
    const staticURL = useStaticURL();
    return (
        <section
            className="panel panel--center"
            style={{
                backgroundImage: `url(${staticURL}img/advert/panel-bg-history.jpg)`,
            }}
        >
            <div className="panel__content panel__content--inverse">
                <div className="lead-in container">
                    <h3 className="lead-in__headline">
                        {t`An American legacy for 130 years`}
                    </h3>
                    <p className="lead-in__copy">
                        {t`Since 1881, millions of people have experienced the exceptional comfort, support, and durability only Sealy can deliver.`}
                    </p>
                    <div className="lead-in__link">
                        <a
                            className="text-link"
                            href="/about-sealy"
                            title={t`See Our History`}
                        >
                            {t`See Our History`}
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};
